import { FC, PropsWithChildren, SVGAttributes } from 'react'
import { cn } from '@utils'

export type SvgIconProps = PropsWithChildren<SVGAttributes<SVGElement>>

export const SvgIcon: FC<SvgIconProps> = ({ children, className, ...props }) => {
  return (
    <svg className={cn('inline-block align-middle', className)} {...props}>
      {children}
    </svg>
  )
}
